import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79307a55"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "TEST", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-mountain fas" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-building fas" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_ctx.entity)
      ? (_openBlock(), _createBlock(_component_el_form, {
          key: 0,
          model: _ctx.entity,
          rules: _ctx.rules,
          "label-position": "top",
          ref: "form"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { lg: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      prop: "station",
                      label: _ctx.$t('label.identifier')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.entity.station,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.entity.station) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { lg: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      prop: "name",
                      label: _ctx.$t('label.name')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.entity.name,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.entity.name) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { lg: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      prop: "stationType",
                      label: _ctx.$t('label.type')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.entity.stationType,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.entity.stationType) = $event)),
                          "value-key": "id",
                          class: "w-100"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stationTypes, (option) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: option.id,
                                label: option.name,
                                value: option
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { lg: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      prop: "container",
                      label: _ctx.$t('label.container')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.entity.container,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.entity.container) = $event)),
                          "value-key": "id",
                          filterable: "",
                          class: "w-100"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.containers, (option) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: option.id,
                                label: option.name,
                                value: option
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { lg: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      prop: "timezone",
                      label: _ctx.$t('label.timeZone')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.entity.timezone,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.entity.timezone) = $event)),
                          filterable: "",
                          class: "w-100"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timezones, (tz) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: tz,
                                label: tz,
                                value: tz
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { lg: 24 }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("label.position")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { lg: 24 }, {
                  default: _withCtx(() => [
                    _hoisted_2,
                    _createVNode(_component_el_tooltip, {
                      class: "box-item",
                      effect: "dark",
                      content: _ctx.entity.office ? _ctx.$t('label.office') : _ctx.$t('label.field'),
                      placement: "bottom"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_switch, {
                          class: "ml-2",
                          modelValue: _ctx.entity.office,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.entity.office) = $event)),
                          "active-color": "#0e3c8e",
                          "inactive-color": "#0e8e25"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["content"]),
                    _hoisted_3
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col),
                _createVNode(_component_el_col, null, {
                  default: _withCtx(() => [
                    _createTextVNode(" Configuración de las Cámaras " + _toDisplayString(_ctx.count) + "/3 ", 1),
                    _createVNode(_component_el_form, { ref: "form-cameras" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_row, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cameras, (item) => {
                              return (_openBlock(), _createBlock(_component_el_col, {
                                span: 8,
                                key: item.id
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    label: item.name,
                                    prop: item.id
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input_number, {
                                        modelValue: item.number,
                                        "onUpdate:modelValue": ($event: any) => ((item.number) = $event),
                                        min: item.min,
                                        max: item.max,
                                        onChange: _ctx.handleChange
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "min", "max", "onChange"])
                                    ]),
                                    _: 2
                                  }, 1032, ["label", "prop"])
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 512)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"]))
      : _createCommentVNode("", true)
  ], 64))
}